import TimeIcon from "@mui/icons-material/AccessTimeRounded";
import { Alert, AlertTitle, Button, Stack } from "@mui/material";
import useToggleState from "@entrilia/shared/hooks/useToggleState";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ChangeRequestDetails } from "../../../../api/types/changeRequestsTypes";
import PendingChangesAlert from "./PendingChangesAlert";

interface Props {
  canUserEdit: boolean;
  pendingChangeRequests: ChangeRequestDetails[];
  onViewRequest: (pendingChangeRequest: ChangeRequestDetails) => void;
}

const PendingChangesSection = ({ canUserEdit, pendingChangeRequests, onViewRequest }: Props) => {
  const [expanded, toggleExpanded] = useToggleState(false);

  if (pendingChangeRequests.length === 0) {
    return null;
  }

  if (pendingChangeRequests.length === 1) {
    return (
      <PendingChangesAlert
        pendingChangeRequest={defined(pendingChangeRequests[0])}
        onViewRequest={onViewRequest}
        showEditingRestrictedNote={canUserEdit}
      />
    );
  }

  return (
    <Alert
      severity="warning"
      iconMapping={{ warning: <TimeIcon fontSize="inherit" /> }}
      sx={{ position: "relative", ".MuiAlert-message": { width: "100%" } }}
    >
      <AlertTitle>{pendingChangeRequests.length} Pending Changes</AlertTitle>
      <Button
        variant="text"
        color="inherit"
        sx={{ position: "absolute", right: 12, top: 12, py: 0 }}
        onClick={toggleExpanded}
      >
        {expanded ? "Hide" : "View all"}
      </Button>
      {expanded && (
        <Stack spacing={2} sx={{ pt: 2 }}>
          {pendingChangeRequests.map((cr) => (
            <PendingChangesAlert
              key={`${cr.workflowId}_${cr.referenceCode}`}
              pendingChangeRequest={cr}
              onViewRequest={onViewRequest}
              showEditingRestrictedNote={canUserEdit}
              hideIcon
            />
          ))}
        </Stack>
      )}
    </Alert>
  );
};

export default PendingChangesSection;
